import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompaniesListComponent } from './companies-list/companies-list.component';
import { CompanyNewComponent } from './company-new/company-new.component';
import { CompanyEditComponent } from './company-edit/company-edit.component';
import { CompaniesAdminRoutingModule } from 'app/companies-admin/companies-admin-routing.module';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CompaniesAdminRoutingModule
    ,SharedModule
  ],
  declarations: [CompaniesListComponent, CompanyNewComponent, CompanyEditComponent]
})
export class CompaniesAdminModule { }



// WEBPACK FOOTER //
// ./src/app/companies-admin/companies-admin.module.ts